// Inspired by: https://github.com/rails/webpacker/issues/161
// But with a few more required hacks

import Vue from 'vue'

window.vueRootComponentReady = function() {
  if ($.isReady) {
    setTimeout(function() {
      $(document).trigger('memorials:vue-root-component-ready');
    }, 0);
  } else {
    $(document).one('turbolinks:load', function(e) {
      $(document).trigger('memorials:vue-root-component-ready');
    });
  }
};

console.log("adding vue init listener to memorials:vue-root-component-ready");
$(document).on('memorials:vue-root-component-ready', function(e) {
  const vueNode = document.getElementById('vue-app');

  if (vueNode) {
    console.log("initializing vue");
    const rootComponentName = vueNode.getAttribute('data-vue-component');
    const RootComponent = window[rootComponentName];
    const app = new Vue(RootComponent).$mount('#vue-app');
    $(document).one('turbolinks:visit', function(e) {
      console.log("destroying vue")
      app.$destroy();
    });
  }

  // Submenu events for orders dropdown.
  window.subMenuEvents();
});
